export const RegexFactory = {
  operationUserNameRegex: /^.{1,6}$/,
  operationUserTelRegex: /(^(1[3-9][0-9])[0-9]{8}$)|^((\d{3,4})(\d{7,8}))$/,
  encodeTelRegex: /(^(1[3-9][0-9])[*]{8}$)$/,
  operationUserQqRegex: /^\d{5,12}$/,
  operationUserWxIdRegex: /^[a-zA-z_-][a-zA-z0-9_-]{5,19}$/,
  mobile: /(^(1[3-9][0-9])[0-9]{8}$)/,
  smsCode: /^\d{6}$/,
  password: /^\d{6}$/,
};
